import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=6152736c&"
import script from "./NewUser.vue?vue&type=script&lang=ts&"
export * from "./NewUser.vue?vue&type=script&lang=ts&"
import style0 from "./NewUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports